import Api from "../../api/Api";

// Action Types
export const NOTIFICATION_ACTIONS = {
  FETCH_NOTIFICATIONS_REQUEST: "FETCH_NOTIFICATIONS_REQUEST",
  FETCH_NOTIFICATIONS_SUCCESS: "FETCH_NOTIFICATIONS_SUCCESS",
  FETCH_NOTIFICATIONS_FAILURE: "FETCH_NOTIFICATIONS_FAILURE",

  FETCH_UNREAD_COUNT_REQUEST: "FETCH_UNREAD_COUNT_REQUEST",
  FETCH_UNREAD_COUNT_SUCCESS: "FETCH_UNREAD_COUNT_SUCCESS",
  FETCH_UNREAD_COUNT_FAILURE: "FETCH_UNREAD_COUNT_FAILURE",

  MARK_AS_READ_REQUEST: "MARK_AS_READ_REQUEST",
  MARK_AS_READ_SUCCESS: "MARK_AS_READ_SUCCESS",
  MARK_AS_READ_FAILURE: "MARK_AS_READ_FAILURE",

  MARK_ALL_AS_READ_REQUEST: "MARK_ALL_AS_READ_REQUEST",
  MARK_ALL_AS_READ_SUCCESS: "MARK_ALL_AS_READ_SUCCESS",
  MARK_ALL_AS_READ_FAILURE: "MARK_ALL_AS_READ_FAILURE",

  DELETE_NOTIFICATION_REQUEST: "DELETE_NOTIFICATION_REQUEST",
  DELETE_NOTIFICATION_SUCCESS: "DELETE_NOTIFICATION_SUCCESS",
  DELETE_NOTIFICATION_FAILURE: "DELETE_NOTIFICATION_FAILURE",

  CREATE_NOTIFICATION_REQUEST: "CREATE_NOTIFICATION_REQUEST",
  CREATE_NOTIFICATION_SUCCESS: "CREATE_NOTIFICATION_SUCCESS",
  CREATE_NOTIFICATION_FAILURE: "CREATE_NOTIFICATION_FAILURE",

  SEND_BROADCAST_REQUEST: "SEND_BROADCAST_REQUEST",
  SEND_BROADCAST_SUCCESS: "SEND_BROADCAST_SUCCESS",
  SEND_BROADCAST_FAILURE: "SEND_BROADCAST_FAILURE",

  ADD_REAL_TIME_NOTIFICATION: "ADD_REAL_TIME_NOTIFICATION",
  UPDATE_NOTIFICATION: "UPDATE_NOTIFICATION",
  REMOVE_NOTIFICATION: "REMOVE_NOTIFICATION",

  SET_FCM_TOKEN: "SET_FCM_TOKEN",
  SET_NOTIFICATION_PERMISSION: "SET_NOTIFICATION_PERMISSION",
};

// Action Creators

// Fetch notifications
export const fetchNotifications =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: NOTIFICATION_ACTIONS.FETCH_NOTIFICATIONS_REQUEST });

    try {
      const queryParams = new URLSearchParams();
      if (params.type) queryParams.append("type", params.type);
      if (params.unread_only) queryParams.append("unread_only", "true");
      if (params.per_page) queryParams.append("per_page", params.per_page);
      if (params.page) queryParams.append("page", params.page);

      const response = await Api.get(
        `/notifications?${queryParams.toString()}`
      );

      if (response.data.success) {
        dispatch({
          type: NOTIFICATION_ACTIONS.FETCH_NOTIFICATIONS_SUCCESS,
          payload: response.data.data,
        });
      } else {
        throw new Error(
          response.data.message || "Failed to fetch notifications"
        );
      }
    } catch (error) {
      dispatch({
        type: NOTIFICATION_ACTIONS.FETCH_NOTIFICATIONS_FAILURE,
        payload: error.message,
      });
    }
  };

// Fetch unread count
export const fetchUnreadCount = () => async (dispatch) => {
  dispatch({ type: NOTIFICATION_ACTIONS.FETCH_UNREAD_COUNT_REQUEST });

  try {
    const response = await Api.get("/notifications/unread/count");

    if (response.data.success) {
      dispatch({
        type: NOTIFICATION_ACTIONS.FETCH_UNREAD_COUNT_SUCCESS,
        payload: response.data.data.unread_count,
      });
    } else {
      throw new Error(response.data.message || "Failed to fetch unread count");
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_ACTIONS.FETCH_UNREAD_COUNT_FAILURE,
      payload: error.message,
    });
  }
};

// Mark notification as read
export const markAsRead = (notificationId) => async (dispatch) => {
  dispatch({
    type: NOTIFICATION_ACTIONS.MARK_AS_READ_REQUEST,
    payload: notificationId,
  });

  try {
    const response = await Api.put(`/notifications/${notificationId}/read`);

    if (response.data.success) {
      dispatch({
        type: NOTIFICATION_ACTIONS.MARK_AS_READ_SUCCESS,
        payload: notificationId,
      });

      // Also update unread count
      dispatch(fetchUnreadCount());
    } else {
      throw new Error(
        response.data.message || "Failed to mark notification as read"
      );
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_ACTIONS.MARK_AS_READ_FAILURE,
      payload: { id: notificationId, error: error.message },
    });
  }
};

// Mark all notifications as read
export const markAllAsRead = () => async (dispatch) => {
  dispatch({ type: NOTIFICATION_ACTIONS.MARK_ALL_AS_READ_REQUEST });

  try {
    const response = await Api.put("/notifications/mark-all-read");

    if (response.data.success) {
      dispatch({
        type: NOTIFICATION_ACTIONS.MARK_ALL_AS_READ_SUCCESS,
      });

      // Also update unread count
      dispatch(fetchUnreadCount());
    } else {
      throw new Error(
        response.data.message || "Failed to mark all notifications as read"
      );
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_ACTIONS.MARK_ALL_AS_READ_FAILURE,
      payload: error.message,
    });
  }
};

// Delete notification
export const deleteNotification = (notificationId) => async (dispatch) => {
  dispatch({
    type: NOTIFICATION_ACTIONS.DELETE_NOTIFICATION_REQUEST,
    payload: notificationId,
  });

  try {
    const response = await Api.delete(`/notifications/${notificationId}`);

    if (response.data.success) {
      dispatch({
        type: NOTIFICATION_ACTIONS.DELETE_NOTIFICATION_SUCCESS,
        payload: notificationId,
      });

      // Also update unread count
      dispatch(fetchUnreadCount());
    } else {
      throw new Error(response.data.message || "Failed to delete notification");
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_ACTIONS.DELETE_NOTIFICATION_FAILURE,
      payload: { id: notificationId, error: error.message },
    });
  }
};

// Create notification
export const createNotification = (notificationData) => async (dispatch) => {
  dispatch({ type: NOTIFICATION_ACTIONS.CREATE_NOTIFICATION_REQUEST });

  try {
    const response = await Api.post("/notifications", notificationData);

    if (response.data.success) {
      dispatch({
        type: NOTIFICATION_ACTIONS.CREATE_NOTIFICATION_SUCCESS,
        payload: response.data.data,
      });

      // Refresh notifications list
      dispatch(fetchNotifications());
    } else {
      throw new Error(response.data.message || "Failed to create notification");
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_ACTIONS.CREATE_NOTIFICATION_FAILURE,
      payload: error.message,
    });
  }
};

// Send broadcast notification
export const sendBroadcast = (broadcastData) => async (dispatch) => {
  dispatch({ type: NOTIFICATION_ACTIONS.SEND_BROADCAST_REQUEST });

  try {
    const response = await Api.post("/notifications/broadcast", broadcastData);

    if (response.data.success) {
      dispatch({
        type: NOTIFICATION_ACTIONS.SEND_BROADCAST_SUCCESS,
        payload: response.data.data,
      });

      // Refresh notifications list
      dispatch(fetchNotifications());
    } else {
      throw new Error(
        response.data.message || "Failed to send broadcast notification"
      );
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_ACTIONS.SEND_BROADCAST_FAILURE,
      payload: error.message,
    });
  }
};

// Real-time notification actions
export const addRealTimeNotification = (notification) => ({
  type: NOTIFICATION_ACTIONS.ADD_REAL_TIME_NOTIFICATION,
  payload: notification,
});

export const updateNotification = (notification) => ({
  type: NOTIFICATION_ACTIONS.UPDATE_NOTIFICATION,
  payload: notification,
});

export const removeNotification = (notificationId) => ({
  type: NOTIFICATION_ACTIONS.REMOVE_NOTIFICATION,
  payload: notificationId,
});

// FCM token actions
export const setFCMToken = (token) => ({
  type: NOTIFICATION_ACTIONS.SET_FCM_TOKEN,
  payload: token,
});

export const setNotificationPermission = (permission) => ({
  type: NOTIFICATION_ACTIONS.SET_NOTIFICATION_PERMISSION,
  payload: permission,
});
